import React, { useEffect, useState } from "react";
import LoginPage from "../modules/Login/LoginPage";
import HomePage from "../modules/Home/HomePage";
//
// import { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
// import { Switch } from "react-router-dom";
import { MasterContext } from "../services/MasterContext";
import * as APIServices from "../services/APIServices";
// import { DataSaverOnOutlined } from "@mui/icons-material";
import Loading from "../App/Loading/Index";


function Greeting(props) {
  const isLoggedIn = props.isLoggedIn;
  return isLoggedIn ? <HomePage /> : <LoginPage setToken={props.setToken} />;
}

function App() {
  const [masterData, setMasterData] = useState({});
  const [userRole, setUserRole] = useState({});
  const storedToken = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState(storedToken ? storedToken : null);
  const userId = localStorage.getItem('userId')
  const isOnline = navigator.onLine;

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 4000);
  // }, []);

  useEffect(() => {

    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    } else {
      setToken(null);
    }

  });

 // Function to handle setting error messages
 function handleError(errorCode) {
  setUserRole(prev => ({ ...prev, error: errorCode }));
}

  useEffect(() => {
    const storedMasterData = localStorage.getItem("masterData");
    if (storedMasterData) {
      setMasterData(JSON.parse(storedMasterData));
    }
    const fetchData = async () => {
      try {
        // APIServices.APIGET(`user/${userId}`);
        await APIServices.APIGET('custom/access',handleError).then(data => {
          if(data){
            setUserRole(data)
          }
        });
      } catch (error) {
        console.error(error);
        // Display a user-friendly error message (optional)
        alert('Failed to fetch data. Please try again later.');
      }
    };
    fetchData();
  }, [token]);

  const handleSetToken = (newToken) => {
    setToken(newToken);
  };

  return (
    <MasterContext.Provider value={{ masterData, userRole, token, handleSetToken }}>
      <Router>
        {isLoading ? <Loading /> :
          <Greeting isLoggedIn={Boolean(token)} setToken={handleSetToken} />
        }
      </Router>
    </MasterContext.Provider>
  );
}

export default App;
